<template>
<v-container max-width="1200">
    <v-card class="pa-4 align-center justify-center">
        <v-card-title>Settings</v-card-title>

        <v-form ref="preferencesForm" lazy-validation>
        <v-layout cols="12" md12 lg8 offset-lg2 xl6 offset-xl3 row>
            <!-- <v-flex xs12 sm6 lg4>
            <v-card class="mx-5 my-4 pa-4">
                <v-card-title>Unit of Measure:</v-card-title>
                <v-card-text>

                <v-select
                    :items="units"
                    v-model="metric"
                    item-text="name"
                    item-value="value"
                />
                </v-card-text>
            </v-card>
            </v-flex> -->
            <v-flex xs12 sm12 lg12>
            <v-card class="mx-5 my-4 pa-4">
                <!-- <v-card-title>
                Notifications
                </v-card-title>
                <v-card-subtitle>
                {{ user.user.notif_allowed == 1 ? "You are currently subscribed to Competition Notifications" : "You are not currently subscribed to Competition Notifications" }}
                </v-card-subtitle>
                <v-btn @click="allow_notifications">Notification Setting</v-btn> -->
                <!-- <v-card-text>{{ notifKey }}</v-card-text> -->
                <NotificationPage/>
            </v-card>
            </v-flex>
            <v-spacer />
            <v-alert v-if="infoMessage !== ''" type="info">
                <span v-html="infoMessage" />
            </v-alert>
            <!-- <v-flex xs12 >
                <v-layout row>
                <v-spacer />
                    <v-btn 
                        class="mt-7 mb-12" 
                        color="primary"
                        :loading="loading" 
                        @click="update_preferences"
                        width="300"
                        >
                        Save
                    </v-btn>
                <v-spacer />
                </v-layout>
            </v-flex> -->
        </v-layout>
        </v-form>
    </v-card>
</v-container>
</template>

<script>
import NotificationPage from './NotificationPage.vue'

// import axios from 'axios'
// import { VDateInput } from 'vuetify/labs/VDateInput'
// import JsonCSV from 'vue-json-csv'
// import { mainStore } from '../store.js '
// const store = mainStore();

export default {
    name: 'SettingsPage',

    components: {
        NotificationPage

    },

    data: () => ({
        errorMessage: '',
        infoMessage: '',
    }),

    methods: {
        // login() {
        //     let data = {
        //         email: this.email,
        //         password: this.password
        //     }
        //     store.login(data)
        //         .then(() => {
        //             this.$router.push({ name: 'admin' })
        //         })
        //         .catch((error) => {
        //             this.errorMessage = error.message
        //         })
        // }

    }

}
</script>
